import { config } from "../../utils/constants";
import axios from "axios";
import { getCurrentLocale } from "../../utils/util";

export const getDependentsInformation = () => {
  const requestConfig = {
    url: `${config.manageDependents}access-list-details`
  };
  return axios.request(requestConfig);
};

export const viewInformation = (patientId) => {
  const requestConfig = {
    url: `${config.manageDependents}dependent-details`,
    method: 'GET',
    params: {
      mrn: patientId
    }
  };
  return axios.request(requestConfig);
};

export const deleteDependentsInformation = (patientId) => {
  const requestConfig = {
    url: `${config.manageDependents}delete-dependent/${patientId}`
  };

  return axios.request(requestConfig);
};

export const verifyDependent = (patientId, emiratesId, yearOfBirth) => {
  let requestBody = {};

  if (patientId) {
    requestBody.patientId = patientId;
  } else if (emiratesId) {
    requestBody.emiratesId = emiratesId;
  }

  requestBody.year = yearOfBirth;
  const requestConfig = {
    method: 'POST',
    url: `${config.manageDependents}verify-dependent`,
    data: requestBody
  };

  return axios.request(requestConfig);
};

export const verifyOtpAndSetProxy = (patientId, emiratesId, otp, id) => {
  let requestBody = {};

  if (patientId) {
    requestBody.patientId = patientId;
  } else if (emiratesId) {
    requestBody.emiratesId = emiratesId;
  }
  requestBody.otp = otp;
  requestBody.id = id;
  const requestConfig = {
    method: 'POST',
    url: `${config.manageDependents}epic-dependent`,
    data: requestBody
  };

  return axios.request(requestConfig);
};

export const APIGateway = (patientId, emiratesId, year) => {
  const locale = getCurrentLocale();
  let requestBody = {};

  if (patientId) {
    requestBody.patientId = patientId;
  } else if (emiratesId) {
    requestBody.emiratesId = emiratesId;
  }
  requestBody.year = year;
  requestBody.locale = locale;
  const requestConfig = {
    method: 'POST',
    url: `${config.manageDependents}api-gateway`,
    data: requestBody
  };

  return axios.request(requestConfig);
};